module.exports = __webpack_public_path__ + "img/verify_success.087d406a.png";